var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransitionGroup',{attrs:{"name":"fade"}},[(_vm.Loading)?_c('Loader',{key:"Loader"}):_c('div',{key:"App",staticClass:"app",class:{
      loading: _vm.Loading,
      dark: _vm.aplicacion.theme,
    }},[_c('Pdf',{attrs:{"aplicacion":_vm.aplicacion}}),_c('Toast',{attrs:{"aplicacion":_vm.aplicacion}}),_c('Header',{staticClass:"app__header",attrs:{"aplicacion":_vm.aplicacion},on:{"language":_vm.SetLanguage,"option":_vm.SetOption}}),_c('Transition',{attrs:{"name":"fade"}},[_c('router-view',{staticClass:"app__view",attrs:{"aplicacion":_vm.aplicacion}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }